module.exports = __webpack_public_path__ + "img/rnd-banner.eea11b3d.png";